<template>
  <div class="page-content receipts">
    <div class="row">
      <div class="col-sm-6 col-12">
        <pull-up-receipt />
        <send-receipt />
      </div>
      <div class="col-sm-6 col-12">
        <send-delivery-history />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { nextTick, onMounted } from 'vue';
import { useRoute } from 'vue-router';

import util from '@/Utils/util';

import PullUpReceipt from './DeliveryReceipts/PullUpReceipt.vue';
import SendReceipt from './DeliveryReceipts/SendReceipt.vue';
import SendDeliveryHistory from './DeliveryReceipts/SendDeliveryHistory.vue';

export default {
  name: 'DeliveryReceipts',

  components: {
    SendReceipt,
    PullUpReceipt,
    SendDeliveryHistory,
  },

  setup: () => {
    onMounted(async () => {
      const route = useRoute();
      const { hash } = route;

      await nextTick();
      util.moveScrollComponent(hash);
    });
  },
};
</script>
